import { Divider, Flex } from "@chakra-ui/react";
import { GamblyButton } from "./GamblyButton";
import { DiscordIcon } from "./icons/DiscordIcon";
import { HeaderLogo } from "./icons/HeaderLogo";

export function Header() {
    return <Flex paddingX="20px" paddingY="15px">
        <HeaderLogo />
        <Divider />
        <Flex gap="10px">
            <GamblyButton onClick={() => {
                window.location.href = "mailto:team@gambly.gg";
            }}>Contact us</GamblyButton>
        </Flex>
    </Flex>
}

// <GamblyButton color="rgba(36, 37, 44, 1)" p="8px" squareSize="42px"><DiscordIcon /></GamblyButton>